/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Security_Enable_Two_Factor_MessageInputs */

const en_security_enable_two_factor_message = /** @type {(inputs: Security_Enable_Two_Factor_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable two-factor authentication to protect your admin access.`)
};

const es_security_enable_two_factor_message = /** @type {(inputs: Security_Enable_Two_Factor_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activa la autenticacion de dos factores para proteger tu acceso de admin.`)
};

/**
* | output |
* | --- |
* | "Enable two-factor authentication to protect your admin access." |
*
* @param {Security_Enable_Two_Factor_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const security_enable_two_factor_message = /** @type {((inputs?: Security_Enable_Two_Factor_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Security_Enable_Two_Factor_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_security_enable_two_factor_message(inputs)
	return es_security_enable_two_factor_message(inputs)
});